// Copyright (c) 2019 Deere & Company

import moment from 'moment';
import React from 'react';

const cellRenderer = params => (
    <a name="claimNumber" data-warrantyClaimId={params.data.warrantyClaimId}>
        {params.data.claimNumber}
    </a>
);

const WorklistTableColumnDefinitions = [

    {
        field: 'claimNumber',
        headerName: 'Claim No',
        sortable: true,
        filter: true,
        width: 110,
        resizable: true,
        cellRenderer,
    },
    {
        field: 'lastUpdatedDate',
        headerName: 'Last Update',
        sortable: true,
        filter: true,
        width: 100,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'branchId',
        headerName: 'Br',
        sortable: true,
        filter: true,
        width: 60,
    },
    {
        field: 'partNumber',
        headerName: 'Part No',
        sortable: true,
        filter: true,
        width: 100,
    },
    {
        field: 'partDescription',
        headerName: 'Prime Part Description',
        sortable: true,
        filter: true,
        width: 150,
    },
    {
        field: 'processDate',
        headerName: 'Process Date',
        sortable: true,
        filter: true,
        width: 110,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'buildDate',
        headerName: 'Build Date',
        sortable: true,
        filter: true,
        width: 110,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'pin.digit13',
        headerName: 'PIN',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'pin.digit17',
        headerName: 'PIN 17',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'auditCode',
        headerName: 'Code',
        sortable: true,
        filter: true,
        width: 70,
    },
    {
        field: 'auditMessage',
        headerName: 'Audit Message',
        sortable: true,
        filter: true,
        width: 200,
        tooltip: data => data.value,
    },
    {
        field: 'complaint',
        headerName: 'Complaint',
        sortable: true,
        filter: true,
        maxWidth: 150,
        tooltip: data => data.value,
    },
    {
        field: 'cause',
        headerName: 'Cause',
        sortable: true,
        filter: true,
        maxWidth: 150,
        tooltip: data => data.value,
    },
    {
        field: 'correction',
        headerName: 'Correction',
        sortable: true,
        filter: true,
        maxWidth: 150,
        tooltip: data => data.value,
    },
    {
        field: 'prodSeriesId',
        headerName: 'Product SeriesId',
        sortable: true,
        filter: true,
        maxWidth: 50,
        tooltip: data => data.value,
    },
    {
        field: 'prodSeriesName',
        headerName: 'Product SeriesName',
        sortable: true,
        filter: true,
        maxWidth: 150,
        tooltip: data => data.value,
    },
    {
        field: 'bmcId',
        headerName: 'BMC ID',
        sortable: true,
        filter: true,
        maxWidth: 100,
        tooltip: data => data.value,
    },
    {
        field: 'bmcName',
        headerName: 'BMC Name',
        sortable: true,
        filter: true,
        maxWidth: 100,
        tooltip: data => data.value,
    },
    {
        field: 'functionCode',
        headerName: 'Function Code',
        sortable: true,
        filter: true,
        maxWidth: 100
    },
    {
        field: 'mfgDeptId',
        headerName: 'MFG Code',
        sortable: true,
        filter: true,
        maxWidth: 100
    },
    {
        field: 'designTeamCode',
        headerName: 'Design Team Code',
        sortable: true,
        filter: true,
        maxWidth: 100
    }
    
];
export default WorklistTableColumnDefinitions;
